import { render, staticRenderFns } from "./CommonManufacturerList.vue?vue&type=template&id=ab0528b4&scoped=true&"
import script from "./CommonManufacturerList.vue?vue&type=script&lang=js&"
export * from "./CommonManufacturerList.vue?vue&type=script&lang=js&"
import style0 from "./CommonManufacturerList.vue?vue&type=style&index=0&id=ab0528b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0528b4",
  null
  
)

export default component.exports